import React from "react";
import { Card, Collapse, message, Empty } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// Log Data Select Element
import LogDataSelectElement from "../../components/SFTPConnector/LogDataSelectElement";
// Log Data Show Element
import LogDataShowElement from "../../components/SFTPConnector/LogDataShowElement";
import Breadcrumb from "../../components/Breadcrumb";
import { SFTPLogSchema } from "../../schema/sftp.schema";
import LoadingComponent from "../../components/Common/LoadingComponent";
// sftp api react query calls
import { useGetJobs, useGetSFTPLogs } from "../../hooks/sftp.hooks";

const cardStyle = { borderRadius: "20px" };

const { Panel } = Collapse;

const Log = () => {
  const { data: SFTPJobData } = useGetJobs();

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(SFTPLogSchema),
    defaultValues: {
      jobId: undefined,
      businessDate: null,
    },
  });

  let logDataSet = watch();
  const enabled = false;

  const logOptions = {
    enabled,
    onSuccess: (SFTPLogDataset) => {
      if (SFTPLogDataset?.length > 0) {
        message.success(
          "Log Is Loaded.Please Check The SFTP Log View & Export Section ",
        );
      } else {
        message.error(
          "No Data In The Log, Please Check With Job Name or Date Range Of You Select",
        );
      }
    },
    onError: (error) => {
      message.error("Internal Server Error");
      console.log(error);
    },
  };

  const {
    isLoading: isSFTPLogData,
    data: SFTPLogData,
    refetch,
  } = useGetSFTPLogs(logDataSet, logOptions);

  const onSubmit = () => {
    refetch();
  };

  return (
    <div>
      <div className="container_aa">
        <h3>SFTP Log</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            {
              path: "Log",
              breadcrumbName: "SFTP Log ",
            },
          ]}
        />
      </div>
      <div className="container_ab">
        <div className="container_style_1_b" style={{ width: "100%" }}>
          <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
            <Panel header="SFTP Log Data Select " key="1">
              <Card style={cardStyle}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <LogDataSelectElement
                    control={control}
                    errors={errors}
                    SFTPJobData={SFTPJobData}
                    Controller={Controller}
                  />
                </form>
              </Card>
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={["2"]} expandIconPosition="right">
            <Panel header="SFTP Log View & Export " key="2">
              <div>
                <Card style={cardStyle}>
                  {isSFTPLogData === true ? (
                    <div className="spinner-log">
                      <LoadingComponent />
                    </div>
                  ) : SFTPLogData?.length > 0 ? (
                    <LogDataShowElement
                      SFTPLogData={SFTPLogData}
                      style={{ maxHeight: "340px" }}
                    />
                  ) : (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_DEFAULT}
                      description={false}
                    />
                  )}
                </Card>
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default Log;
